import React, {useCallback, useRef} from 'react';
import DotsLoading from '../dotsLoading';

interface InfinitScrollProps {
  children: React.ReactNode;
  isloading: boolean;
  onWatchEnd: () => void;
  isEndSeenReverse?: boolean;
}
const InfinitScroll = ({
  children,
  isloading,
  isEndSeenReverse,
  onWatchEnd,
}: InfinitScrollProps) => {
  const observer = useRef<IntersectionObserver | null>(null);

  const lastElementChat = useCallback(
    (node: HTMLDivElement) => {
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          onWatchEnd();
        }
      });
      if (node) observer.current.observe(node);
    },
    [onWatchEnd],
  );
  return (
    <>
      {isEndSeenReverse && <div ref={lastElementChat} />}
      {isloading ? (
        <div className="w-100 flex justify-center items-center pt-4">
          <DotsLoading />
        </div>
      ) : (
        children
      )}
      {!isEndSeenReverse && <div ref={lastElementChat} />}
    </>
  );
};

export default InfinitScroll;
